export function isInViewport(rect: DOMRect) {
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= window.innerHeight &&
    rect.right <= window.innerWidth
  );
}

/**
 *
 * @param rect
 * @param offsetPct offset as a percentage.  the distance will be adjusted by this
 *   value.  for example, to get the distance 20% down from the top of the screen,
 *   use an offset value of -30%, which will move the content up by 30% the height
 *   of the viewport, which starts at 50%.  Up is negative, down is positive.
 * @returns
 */
export function getDistanceFromCenterOfScreen(rect: DOMRect, offsetPct = 0) {
  const offset = window.innerHeight * (offsetPct / 100);
  return rect.top - window.innerHeight / 2 - offset;
}
